export default __webpack_public_path__ + "static/media/calleja.278a2a95.jpg";